import { render } from "./addressSelect.vue?vue&type=template&id=4df81589"
import script from "./addressSelect.vue?vue&type=script&lang=js"
export * from "./addressSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__